module.exports = __webpack_public_path__ + "media/open-sans/OpenSans-ExtraBoldItalic-8d9710e1.eot";